export enum MUTATION_TYPES {
  SET_LOGIN_DATA = "SET_LOGIN_DATA",
  SET_SOCIAL_LOGIN = "SET_SOCIAL_LOGIN",
  SET_USER = "SET_USER",
  SET_VERIFICATION_STATUS = "SET_VERIFICATION_STATUS",
  SET_USER_VERIFICATION_STATUS = "SET_USER_VERIFICATION_STATUS",
  SET_CREDITCARD_STATUS = "SET_CREDITCARD_STATUS",
  SET_REDIRECT_PATH = "SET_REDIRECT_PATH",
  SET_DO_NOT_DISTURB = "SET_DO_NOT_DISTURB",
  SET_USER_BALANCE = "SET_USER_BALANCE",
  SET_STATE = "SET_STATE",
  SET_DARK_MODE = "SET_DARK_MODE",
  SET_NSFW_USER_SETTING = "SET_NSFW_USER_SETTING",
  LOGOUT = "LOGOUT",
}

export enum ACTION_TYPES {
  LOGIN = "LOGIN",
  LOGOUT = "LOGOUT",
  GET_SYSTEM_SETTINGS = "GET_SYSTEM_SETTINGS",
  GET_VERIFICATION_STATUS = "GET_VERIFICATION_STATUS",
  GET_CREDITCARD_STATUS = "GET_CREDITCARD_STATUS",
  GET_NSFW_USER_SETTING = "GET_NSFW_USER_SETTING",
}
